import { Component, Input } from '@angular/core';
import { BwsBreadCrumb } from '@shared/components/breadcrumb/breadcrumb.component';

@Component({
    selector: 'bws-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent {

  @Input() breadCrumbItems: BwsBreadCrumb[] = [];
  @Input() breadCrumbTitle: string = '';
  @Input() breadCrumbNavigateBackLink: string = '';

  @Input() mobileOnly: boolean = true;


  public toggleSidebar(): void {
    document.getElementById('sidebar')?.classList.toggle('drawer-on');
  }

}
